<template>
  <b-list-group class="select-field">
    <component
      :is="labelTag"
      :class="{'mr-50': !labelTop, 'mb-0': !labelTop}"
    >{{ label }}</component>
    <v-select
      v-model="selected"
      :options="options"
      :label="labelField"
      :input-id="inputId"
      :placeholder="placeholder"
      :multiple="multiple"
      class="w-100"
      @input="$emit('change', selected)"
    >
      <span slot="no-options">{{ noOptionsText }}</span>
    </v-select>
  </b-list-group>
</template>

<script>

import vSelect from 'vue-select'
import { computed, ref } from 'vue'
import { BListGroup } from 'bootstrap-vue'

export default {
  name: 'VSelectField',
  components: {
    vSelect, BListGroup
  },
  emits: ['change'],
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    noOptionsText: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    labelField: {
      type: String,
      required: false,
      default: () => 'label',
    },
    labelTop: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    smallLabel: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  setup(props) {
    const selected = ref(null)
    const labelTag = computed(() => props.smallLabel ? 'label' : 'h6')

    return {
      selected,
      labelTag
    }
  }
}
</script>
